import React, { useEffect, useState } from "react";
import "../../../assets/styles/invoicePrint.scss";
import rcIcon from '../../../assets/images/vital-impact-sub-logo.svg';
import { commonPostApi } from "../../../utils/apiService";

const InvoicePrint = ({ invoiceData }) => {

  
  return (
    <div className="invoice-print">
      <div className="header">
        <div className="flex gap-2 ">
          <img src={rcIcon} className="invoice-header-logo-sec" />
          {/* <div className="detail-title">vital-impact</div> */}
        </div>
        <div className="spacing"></div>
        <div className="divider" />
        <div className="spacing"></div>
        <div className="container-wapper">
          <div>
            <div className="patient-label">
              Patient Name: <span className="patient-detail-value">{invoiceData?.patient_name}</span>
            </div>
            <div className="patient-label">
              Patient Id: <span className="patient-detail-value">{invoiceData?.patient_code}</span>
            </div>
          </div>
          <div>
            <div className="patient-label">
              Camp Date (Token Issued): <span className="patient-detail-value">{invoiceData?.invoice_date}</span>
            </div>
            <div className="patient-label">
              Date of Reporting: <span className="patient-detail-value">{invoiceData?.invoice_date}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="invoice-center">
        <div className="invoice-badge">
          <div>Invoice: <span className="patient-detail-value">{invoiceData?.invoice_code}</span></div>
        </div>
      </div>

      <div className="invoice-details-container">
        <div className="left-details">
          <div className="patient-label">
            Camp Date: <span className="patient-detail-value">{invoiceData?.camp_date}</span>
          </div>
          <div className="patient-label">
            Patient Name: <span className="patient-detail-value">{invoiceData?.patient_name}</span>
          </div>
        </div>
        <div className="divider"></div>
        <div className="right-details">
          <div className="patient-label">Patient Visit Details:</div>
          <div className="visit-dates">{invoiceData?.visits?.join(", ")}</div>
        </div>
      </div>

      <div className="spacing"></div>

      <table>
        <tr>
          <th className="header-names">S NO</th>
          <th className="header-names"> DESCRIPTION</th>
          <th className="header-names">AMOUNT</th>
        </tr>
        <tbody>
          {invoiceData?.payment_categories?.map((item, index) => (
            <tr key={index}>
              <td className="patient-detail-value">{index + 1}</td>
              <td className="patient-detail-value">{item.description}</td>
              <td className="patient-detail-value">₹ {item.collectable_amount}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="total-amount">
        <div>
          <span className="sub-range">Total: ₹ {invoiceData?.total_collectable_amount}</span>
        </div>
      </div>
      <div className="patient-label">
        Amount in Figures: <span className="sub-range">{invoiceData?.total_collectable_amount_in_words}</span>
      </div>
      <div className="footer-row">
        <div className="patient-label">
          Prepared & Collected by: <span className="patient-detail-value">{invoiceData?.prepared_and_collected_by}</span>
        </div>
        <div p className="patient-label">
          Volunteer Name: <span className="patient-detail-value">{invoiceData?.volunter_name}</span>
        </div>
      </div>
    </div>
  );
};

export default InvoicePrint;
